import {
  getJurisdictionsByCountry,
  type JurisdictionOptionResponse,
} from '@/pages/api/scribeAPIV2';
import { logger } from '@/utils/logger/logger';
import { useQuery } from '@tanstack/react-query';

export const GET_JURISDICTIONS = 'getJurisdictions';

export async function fetchJurisdictionsByCountry(
  countryName?: string | null
): Promise<JurisdictionOptionResponse[]> {
  const normalizedCountryName = countryName?.trim();
  if (!normalizedCountryName) return [];

  try {
    const { data } = await getJurisdictionsByCountry(normalizedCountryName);
    return data;
  } catch (error) {
    logger.warn(
      'Failed to fetch jurisdictions from backend. Falling back to local ISO list.',
      {
        countryName: normalizedCountryName,
        error,
      }
    );
    return [];
  }
}

export function useQueryJurisdictions(countryName?: string | null) {
  const normalizedCountryName = countryName?.trim();

  return useQuery<JurisdictionOptionResponse[]>({
    queryKey: [GET_JURISDICTIONS, normalizedCountryName],
    enabled: Boolean(normalizedCountryName),
    queryFn: () => fetchJurisdictionsByCountry(normalizedCountryName),
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
}
